// extracted by mini-css-extract-plugin
module.exports = {"NoteHeader":"styles_NoteHeader__2ByvZ","NoteHeader__Close":"styles_NoteHeader__Close__1HZkA"};